import { render, staticRenderFns } from "./SmallBaseCard.vue?vue&type=template&id=0c563d76&scoped=true"
import script from "./SmallBaseCard.vue?vue&type=script&lang=js"
export * from "./SmallBaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c563d76",
  null
  
)

export default component.exports